import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import IsEmpty from 'lodash/isEmpty';

import OrderItemMeal from 'onramp/ui/components/OrderItemMeal';
import Loading from 'core/ui/components/Loading';
import { isLoading } from 'core/api/loadingHelpers';
import { GET_LIST_ADDONS } from 'core/api/apollo/queries';
import { Box, Text } from 'core/ui/atoms';

const Addons = ({
  deliveryDayId,
  title = 'ADD-ONS',
  subtitle = 'Add a little extra flavor to your meal!',
  refetchBillingSummary,
}) => {
  const variables = { deliveryDayId: deliveryDayId };

  const { loading, error, data: { listAddons = [] } = {} } = useQuery(GET_LIST_ADDONS, {
    variables,
    skip: IsEmpty(deliveryDayId),
  });

  if (isLoading(loading, listAddons, error)) {
    return <Loading />;
  }

  const RenderOrderItem = () => {
    return listAddons.map((item, index) => (
      <OrderItemMeal
        key={index}
        item={item}
        isAddOn={true}
        deliveryDayId={deliveryDayId}
        refetchBillingSummary={refetchBillingSummary}
      />
    ));
  };

  return (
    <Box>
      <Title>{title}</Title>
      <Description>{subtitle}</Description>
      <RenderOrderItem />
    </Box>
  );
};

Addons.propTypes = {
  deliveryDayId: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  refetchBillingSummary: PropTypes.func,
};

const Title = styled(Text)`
  color: #36443A;
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`;

const Description = styled(Text)`
  color: #36443A;
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 30px;
  padding-left: 25px;
  padding-right: 25px;
`;

export default Addons;
